/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";

const pageWrapperStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 32px;
  padding-left: 32px;
  padding-right: 32px;
`;

export const PageWrapper = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div css={pageWrapperStyle} {...rest}>
      {children}
    </div>
  );
};
